'use client';
import { useEffect } from 'react';
import { Button } from '@/components/ui/button';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => { console.error(error); }, [error]);
  return (
    <main className="container py-16 text-center space-y-4">
      <h1 className="text-2xl font-semibold">Something broke on our side.</h1>
      <p className="text-sm text-muted-foreground">
        {error.digest ? `Reference: ${error.digest}` : 'Please try again.'}
      </p>
      <Button onClick={reset}>Retry</Button>
    </main>
  );
}
